import VenueOpeningHoursEditMode from './VenueOpeningHoursEditMode';

export default VenueOpeningHoursEditMode;
